import request from '@/utils/request'

export function changePassword (data) {
  return request({
    url: '/user/profile/password',
    method: 'put',
    data
  })
}
export function getProfile () {
  return request({
    url: '/user/profile',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/profile.js